import { cn } from '@/shadcn-ui/utils';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function CarEmergencyLight({ className }: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[17px] w-[18px]', className)}
    >
      <path
        d="M4.46875 13.4297H13.5234C13.7005 13.4297 13.8307 13.3568 13.9141 13.2109C14.0026 13.0651 14.0026 12.9141 13.9141 12.7578L9.39062 4.79688C9.29688 4.63542 9.16406 4.55469 8.99219 4.55469C8.82552 4.55469 8.69531 4.63542 8.60156 4.79688L4.07812 12.7578C3.98958 12.9193 3.98698 13.0729 4.07031 13.2188C4.15885 13.3594 4.29167 13.4297 4.46875 13.4297ZM6.48438 11.8984C6.45312 11.8984 6.42708 11.8854 6.40625 11.8594C6.39062 11.8281 6.39323 11.7917 6.41406 11.75L8.92969 7.35938C8.94531 7.32812 8.96875 7.3125 9 7.3125C9.03125 7.3125 9.05729 7.32812 9.07812 7.35938L11.5859 11.75C11.6068 11.7917 11.6094 11.8281 11.5938 11.8594C11.5781 11.8854 11.5521 11.8984 11.5156 11.8984H6.48438ZM2.99219 16.0469C2.51302 16.0469 2.09635 15.9375 1.74219 15.7188C1.38802 15.5052 1.11198 15.2188 0.914062 14.8594C0.716146 14.5 0.617188 14.1068 0.617188 13.6797C0.617188 13.263 0.723958 12.8672 0.9375 12.4922L6.96094 1.97656C7.17969 1.58594 7.47396 1.29167 7.84375 1.09375C8.21354 0.890625 8.59896 0.789062 9 0.789062C9.40104 0.789062 9.78385 0.888021 10.1484 1.08594C10.513 1.28385 10.8099 1.58073 11.0391 1.97656L17.0547 12.4844C17.1641 12.6771 17.2448 12.875 17.2969 13.0781C17.349 13.276 17.375 13.4766 17.375 13.6797C17.375 14.1068 17.276 14.5 17.0781 14.8594C16.8854 15.2188 16.612 15.5052 16.2578 15.7188C15.9036 15.9375 15.487 16.0469 15.0078 16.0469H2.99219Z"
        fill="url(#paint0_radial_7923_17141)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_7923_17141"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(27 23.6522) rotate(-123.311) scale(54.6271 126.699)"
        >
          <stop offset="0.212916" stopColor="#0F112E" />
          <stop offset="0.278316" stopColor="#53759B" />
          <stop offset="0.405" stopColor="#131636" />
          <stop offset="1" stopColor="#010118" />
        </radialGradient>
      </defs>
    </svg>
  );
}
